export const exteriorCheckboxes = [
  {
    id: '1',
    field: 'bodyCondition',
    name: 'Body Condition',
    description: 'Check for dents, scratches, and signs of previous accidents.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '2',
    field: 'glassAndMirrors',
    name: 'Glass And Mirrors',
    description: ' Inspect windshields, windows, and mirrors for cracks and damage.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '3',
    field: 'licencePlates',
    name: 'Licence Plates',
    description: 'Verify the presence and visibility of front and rear license plates.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '4',
    field: 'light',
    name: 'Light',
    description:
      'Test headlights, taillights, brake lights, turn signals, and hazard lights.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '5',
    field: 'tires',
    name: 'Tires',
    description: ' Check tire condition, tread depth, and inflation pressure.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  }
];
export const interiorCheckboxes = [
  {
    id: '1',
    field: 'seatBelts',
    name: 'Seat Belts',
    description: 'Ensure all seatbelts are functional and in good condition.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '2',
    field: 'dashboard',
    name: 'Dashboard',
    document: '',
    description: 'Check warning lights and gauges for proper functionality.',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '3',
    field: 'controls',
    name: 'Controls',
    document: '',
    description: ' Test all interior controls (e.g., AC, radio, windows, locks).',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '4',
    field: 'seatsAndUpholstery',
    name: 'Seats And Up holstery',
    description: ' Inspect seats and upholstery for tears or damage',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '5',
    field: 'floorMats',
    name: 'Floor Mats',
    description: 'Check for proper floor mat installation and secure them in place',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  }
];

export const engineCheckboxes = [
  {
    id: '1',
    field: 'fluidLevels',
    name: 'Fluid Levels',
    description:
      ' Check engine oil, coolant, brake fluid, and windshield washer fluid levels.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '2',
    field: 'beltsAndHoses',
    name: 'Belts And Hoses',
    description: ' Inspect belts and hoses for signs of wear or damage.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '3',
    field: 'battery',
    name: 'Battery',
    description: ' Check battery terminals and ensure they are clean and secure.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '4',
    field: 'engineCondition',
    name: 'Engine Condition',
    description: ': Look for leaks or signs of engine problems.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  }
];

export const underCarriageCheckboxes = [
  {
    id: '1',
    field: 'exhaustSystem',
    name: 'Exhaust System',
    description: 'Check for leaks, rust, and damage in the exhaust system.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '2',
    field: 'suspension',
    name: 'Suspension',
    description: 'Inspect shocks, struts, and suspension components.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '3',
    field: 'brakes',
    name: 'Brakes',
    description: 'Check brake lines, pads, and rotors for wear.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '4',
    field: 'steering',
    name: 'Steering',
    description: 'Test the steering system for smooth operation.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  }
];

export const safetyCheckboxes = [
  {
    id: '1',
    field: 'spareTireAndTools',
    name: 'Spare Tire And Tools',
    description: 'Verify the presence of a functional spare tire and tools.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '2',
    field: 'jack',
    name: 'Jack',
    description: 'Check the functionality and condition of the vehicle jack.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '3',
    field: 'warningTriangles',
    name: 'Warning Triangles',
    description: `Ensure warning triangles are available in case of emergencies.`,
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '4',
    field: 'firstAidKid',
    name: 'First Aid Kid',
    description: `Check for the presence and completeness of a first aid kit.`,
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  }
];
export const vehicleCheckboxes = [
  {
    id: '1',
    field: 'vehicleRegistration',
    name: 'Vehicle Registration',
    description: `Verify that the vehicle registration is valid and up-to-date.`,
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '2',
    field: 'insurance',
    name: 'Insurance',
    description: `Ensure the vehicle is adequately insured.`,
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '3',
    field: 'serviceRecords',
    name: 'Service Records',
    description: `Review the vehicle's service history and maintenance records.`,
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '4',
    field: 'ownersManual',
    name: 'Owners Manual',
    description: `Check for the presence of the vehicle's owner's manual.`,
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  }
];
export const complianceCheckboxes = [
  {
    id: '1',
    field: 'emissionControlSystem',
    name: 'Emission Control System',
    description: ' Check for compliance with emission standards.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '2',
    field: 'vehicleInspectionSticker',
    name: 'Vehicle Inspection Sticker',
    description: 'Ensure the vehicle has a valid inspection sticker.',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  },
  {
    id: '3',
    field: 'complianceWithLocalRegulation',
    name: 'Compliance With Local Regulation Service Records',
    description: ' Verify compliance with local vehicle regulations',
    document: '',
    documentFile: null,
    categorycheck: [
      { name: 'Yes', checked: false },
      { name: 'No', checked: false },
      { name: 'N/A', checked: false }
    ]
  }
];

export const cardCheckBoxDetails = [
  {
    title: 'Exterior Inspection Details',
    field: 'exteriorInspection',
    category: [
      {
        name: 'selectAllYes',
        label: 'Select All Yes',
        value: 'Yes',
        checked: false
      },
      {
        name: 'selectAllNo',
        label: 'Select All No',
        value: 'No',
        checked: false
      },
      {
        name: 'selectAllNA',
        label: 'Select All NA',
        value: 'N/A',
        checked: false
      }
    ],
    categoryList: exteriorCheckboxes,
    description: [
      {
        id: '1',
        name: 'description',
        label: 'Description',
        value: ''
      }
    ]
  },
  {
    title: 'Interior Inspection Details',
    field: 'interiorInspection',
    category: [
      {
        name: 'selectAllYes',
        label: 'Select All Yes',
        value: 'Yes',
        checked: false
      },
      {
        name: 'selectAllNo',
        label: 'Select All No',
        value: 'No',
        checked: false
      },
      {
        name: 'selectAllNA',
        label: 'Select All NA',
        value: 'N/A',
        checked: false
      }
    ],
    categoryList: interiorCheckboxes,
    description: [
      {
        id: '2',
        name: 'description',
        label: 'Description'
      }
    ]
  },
  {
    title: 'Engine Compartment',
    field: 'engineCompartment',
    category: [
      {
        name: 'selectAllYes',
        label: 'Select All Yes',
        value: 'Yes',
        checked: false
      },
      {
        name: 'selectAllNo',
        label: 'Select All No',
        value: 'No',
        checked: false
      },
      {
        name: 'selectAllNA',
        label: 'Select All NA',
        value: 'N/A',
        checked: false
      }
    ],
    categoryList: engineCheckboxes,
    description: [
      {
        id: '3',
        name: 'description',
        label: 'Description',
        value: ''
      }
    ]
  },
  {
    title: 'Under Carriage Inspection',
    field: 'undercarriageInspection',
    category: [
      {
        name: 'selectAllYes',
        label: 'Select All Yes',
        value: 'Yes',
        checked: false
      },
      {
        name: 'selectAllNo',
        label: 'Select All No',
        value: 'No',
        checked: false
      },
      {
        name: 'selectAllNA',
        label: 'Select All NA',
        value: 'N/A',
        checked: false
      }
    ],
    categoryList: underCarriageCheckboxes,
    description: [
      {
        id: '4',
        name: 'description',
        label: 'Description',
        value: ''
      }
    ]
  },
  {
    title: 'Safety Equipment',
    field: 'safetyEquipment',
    category: [
      {
        name: 'selectAllYes',
        label: 'Select All Yes',
        value: 'Yes',
        checked: false
      },
      {
        name: 'selectAllNo',
        label: 'Select All No',
        value: 'No',
        checked: false
      },
      {
        name: 'selectAllNA',
        label: 'Select All NA',
        value: 'N/A',
        checked: false
      }
    ],
    categoryList: safetyCheckboxes,
    description: [
      {
        id: '5',
        name: 'description',
        label: 'Description',
        value: ''
      }
    ]
  },
  {
    title: 'Vehicle Documentation',
    field: 'vehicleDocumentation',
    category: [
      {
        name: 'selectAllYes',
        label: 'Select All Yes',
        value: 'Yes',
        checked: false
      },
      {
        name: 'selectAllNo',
        label: 'Select All No',
        value: 'No',
        checked: false
      },
      {
        name: 'selectAllNA',
        label: 'Select All NA',
        value: 'N/A',
        checked: false
      }
    ],
    categoryList: vehicleCheckboxes,
    description: [
      {
        id: '6',
        name: 'description',
        label: 'Description',
        value: ''
      }
    ]
  },
  {
    title: 'Compliance And Emissions',
    field: 'complianceAndEmissions',
    category: [
      {
        name: 'selectAllYes',
        label: 'Select All Yes',
        value: 'Yes',
        checked: false
      },
      {
        name: 'selectAllNo',
        label: 'Select All No',
        value: 'No',
        checked: false
      },
      {
        name: 'selectAllNA',
        label: 'Select All NA',
        value: 'N/A',
        checked: false
      }
    ],
    categoryList: complianceCheckboxes,
    description: [
      {
        id: '7',
        name: 'description',
        label: 'Description',
        value: ''
      }
    ]
  }
];
